import { cleanNotifications, showNotification } from '@mantine/notifications'

// Default notification configuration
const defaultNotificationProps = {
  position: 'top-right',
  autoClose: false,
  color: 'yellow',
  styles: {
    root: {
      position: 'fixed',
      top: '84px',
      right: '10px',
      zIndex: 20000,
      maxWidth: '400px',
    },
  },
}

/**
 * Utility function to show a notification with default props.
 * Custom options can override the defaults.
 *
 * @param {Object} options - Custom options to override the default notification props.
 * @returns {string} notificationId - The ID of the displayed notification.
 */
export function showCustomNotification(options) {
  const notificationId = options.id || Date.now() // Ensure a unique ID
  showNotification({
    id: notificationId, // Assign a unique ID for later reference
    ...defaultNotificationProps,
    ...options,
  })
  return notificationId // Return the ID so it can be used to close the notification
}

/**
 * Utility function to close a specific notification by ID.
 *
 * @param {string} notificationId - The ID of the notification to close.
 */
export function closeCustomNotification(notificationId) {
  notificationId ? cleanNotifications(notificationId) : cleanNotifications()
}
